import { render } from "./TheCompareWidget.vue?vue&type=template&id=188a995c"
import script from "./TheCompareWidget.vue?vue&type=script&lang=js"
export * from "./TheCompareWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__